<template>
    <div v-if="value">
        <az-sub-title :title="title ? title : 'Regras'" class="mt-3">
            <a href="#" @click.prevent="incluir_regra()" class="card-link">
                <i class="fa fa-plus" aria-hidden="true"></i>
                Incluir Regra
            </a>
        </az-sub-title>
        <template v-if="value">
            <div class="form-row" v-for="(regra, irx) in value" :key="irx">
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        :label="irx ? '' : 'Id'"
                        required
                        :validate="validate"
                        v-model="regra.id">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_regra(irx)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        :label="irx ? '' : 'Tipo'"
                        type="select"
                        :optionsList="[
                            { id: 'text', search: 'Texto' },
                            { id: 'number', search: 'Número' },
                            { id: 'checkbox', search: 'Verdadeiro/Falso' },
                            { id: 'sv', search: 'Pontos Score' },
                        ]"
                        optionsData="id"
                        required
                        :validate="validate"
                        v-model="regra.type" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        :label="irx ? '' : 'Operador'"
                        type="select"
                        :optionsList="[
                            { id: '=', search: 'Igual' },
                            { id: '<>', search: 'Diferente' },
                            { id: '>', search: 'Maior que' },
                            { id: '>=', search: 'Maior/Igual a' },
                            { id: '<', search: 'Menor que' },
                            { id: '<=', search: 'Menor/Igual a' },
                            { id: 'in', search: 'Lista' },
                            { id: 'nin', search: 'Fora da lista' },
                            { id: 'likes', search: 'Começar com' },
                            { id: 'nlikes', search: 'Não Começar com' },
                            { id: 'like', search: 'Contém' },
                            { id: 'nlike', search: 'Não Contém' },
                            { id: 'is-not-null', search: 'Com Valor' },
                        ]"
                        optionsData="id"
                        required
                        :edicao="regra.type != 'checkbox'"
                        :validate="validate"
                        v-model="regra.oper" />
                </div>
                <div class="col col-12 col-md-2" v-if="regra.oper != 'is-not-null'">
                    <az-input
                        v-if="regra.type == 'checkbox'"
                        sizing="sm"
                        :label="irx ? '' : 'Valor'"
                        :validate="validate"
                        type="checkbox"
                        v-model="regra.value" />

                    <az-input
                        v-else
                        sizing="sm"
                        :label="irx ? '' : 'Valor'"
                        required
                        :validate="validate"
                        v-model="regra.value" />
                </div>
                <div class="col col-12 col-md-2" v-if="regra.type == 'checkbox' && !block_grupo">
                    <az-input   
                        sizing="sm"
                        :label="irx ? '' : 'Grupo'"
                        :validate="validate"
                        v-model="regra.group" />
                </div>
                <div class="col col-12 col-md-2" v-if="false">
                    <az-input
                        sizing="sm"
                        type="checkbox"
                        :label="irx ? '' : 'Obrigatório'"
                        :validate="validate"
                        v-model="regra.required" />
                </div>
            </div>

        </template>
        <span v-if="!value || !value.length" class="text-muted">
            Nenhuma
        </span>
    </div>
</template>

<script>
//import _ from 'lodash';
//import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    components: { 
        AzInput,
        AzSubTitle,
    },

    props: ['value', 'title', 'block_grupo', 'validate'], 

    methods: { 
        incluir_regra() { 
            this.value.push({
                id: '',
                type: 'text',
                oper: '=',
                value: '',
                required: true, 
            });
        },

        remover_regra(irx) { 
            this.value.splice(irx, 1);
        },
    }
}
</script>
